import React, { useEffect, useMemo, useState } from 'react';

import { calculateRowTotals } from '../../utils/calculations';
import { getIndentClass } from '../../utils/styleUtils';

import MilestoneTypeRow from './MilestoneTypeRow';
import SponsorMilestoneData from './SponsorMilestoneData';

import { formatFigure } from 'Helpers/formatService';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function UncommittedSection(props) {
    const [showUncommittedChildren, setShowUncommittedChildren] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'uncommitted' || t.batch === 'projects uncommitted') {
            setShowUncommittedChildren(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level
    const indentLevel = props.indentLevel || 3;
    const childIndentLevel = indentLevel + 1;

    const toggleUncommittedShow = () => {
        setShowUncommittedChildren(!showUncommittedChildren);
    };

    const uncommitted = props.sponsor.uncommitted;
    if (!uncommitted) return null;

    const { maxSponsorMilestonesCount } = props;

    const vikTotals = useMemo(() => {
        return calculateRowTotals(uncommitted.milestones.vik);
    }, [uncommitted.milestones.vik]);

    const cashTotals = useMemo(() => {
        return calculateRowTotals(uncommitted.milestones.cash);
    }, [uncommitted.milestones.cash]);

    return (
        <>
            <tr className="!tw-bg-gray-50">
                <td>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 tw-cursor-pointer ${getIndentClass(indentLevel)}`} onClick={toggleUncommittedShow}>
                        <div className="tw-font-medium tw-text-gray-700">{$t('Uncommitted')}</div>
                        <div>{showUncommittedChildren ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4 "></td>
                <td className="tw-p-4 tw-text-right tw-text-gray-700 tw-border-r-2">{formatFigure(uncommitted.value)}</td>
                {uncommitted.currentMilestones &&
                    [...Array(maxSponsorMilestonesCount)].map((e, i) => {
                        return (
                            <React.Fragment key={`uncommitted_milestones_${i}`}>
                                <SponsorMilestoneData
                                    key={`${props.keyPrefix || ''}uncommitted_${props.sponsor.id}_milestone_${i}`}
                                    milestones={uncommitted.currentMilestones}
                                    milestoneId={i}
                                    keyPrefix={props.keyPrefix || ''}
                                    amountOnly={true}
                                    isCommitted={false}
                                />
                            </React.Fragment>
                        );
                    })}
                <td className="tw-p-4 tw-text-right tw-border-r-2"></td>
                <td className="tw-p-4 tw-text-right tw-border-r-2">{formatFigure((vikTotals.totalValue ?? 0) + (cashTotals.totalValue ?? 0))}</td>
                <td className="tw-p-4 tw-text-right tw-border-r-2"></td>
            </tr>
            {showUncommittedChildren && (
                <>
                    <MilestoneTypeRow
                        {...props}
                        key={`uncommitted_cash_${props.sponsor.id}`}
                        type="cash"
                        label="Cash"
                        data={uncommitted}
                        periods={props.periods}
                        indentLevel={childIndentLevel}
                        sponsor={props.sponsor}
                        rowTotalValue={Math.max(0, uncommitted.value - uncommitted.vik)}
                    />
                    <MilestoneTypeRow
                        {...props}
                        key={`uncommitted_vik_${props.sponsor.id}`}
                        type="vik"
                        label="VIK"
                        data={uncommitted}
                        periods={props.periods}
                        indentLevel={childIndentLevel}
                        sponsor={props.sponsor}
                        rowTotalValue={uncommitted.vik}
                    />
                </>
            )}
        </>
    );
}
